// Generated by scripts/gen-image-sizes.js. Do not edit.
import i0 from "./About.jpg";
import i1 from "./Artifice Studio.jpeg";
import i2 from "./BCard/1.jpg";
import i3 from "./BCard/2_1.jpg";
import i4 from "./BCard/2_2.jpg";
import i5 from "./BCard/3.jpg";
import i6 from "./BCard/4_1.jpg";
import i7 from "./BCard/4_2.jpg";
import i8 from "./BCard/5.jpg";
import i9 from "./B_Card.jpg";
import i10 from "./FAQs.jpg";
import i11 from "./Flyer/Dance.jpg";
import i12 from "./Flyer/FCV.jpg";
import i13 from "./Flyer/Racing.jpg";
import i14 from "./Flyer/Racing_Mockup.jpg";
import i15 from "./Flyer/Sports.jpg";
import i16 from "./Logo_Design.jpg";
import i17 from "./Packging/1.jpg";
import i18 from "./Packging/2.jpg";
import i19 from "./Packging/3.jpg";
import i20 from "./Packging/4.jpg";
import i21 from "./Packging/5.jpg";
import i22 from "./Packging/6.jpg";
import i23 from "./Packging/Packging.jpg";
import i24 from "./Portfolio_Logo/1.png";
import i25 from "./Portfolio_Logo/2.png";
import i26 from "./Portfolio_Logo/3.png";
import i27 from "./Portfolio_Logo/4.png";
import i28 from "./Portfolio_Logo/5.png";
import i29 from "./Portfolio_Logo/6.png";
import i30 from "./Portfolio_Logo/Logo1.jpg";
import i31 from "./Portfolio_Logo/Logo10.jpg";
import i32 from "./Portfolio_Logo/Logo11.jpg";
import i33 from "./Portfolio_Logo/Logo12.jpg";
import i34 from "./Portfolio_Logo/Logo13.jpg";
import i35 from "./Portfolio_Logo/Logo14.jpg";
import i36 from "./Portfolio_Logo/Logo15.jpg";
import i37 from "./Portfolio_Logo/Logo16.jpg";
import i38 from "./Portfolio_Logo/Logo17.jpg";
import i39 from "./Portfolio_Logo/Logo18.jpg";
import i40 from "./Portfolio_Logo/Logo19.jpg";
import i41 from "./Portfolio_Logo/Logo2.jpg";
import i42 from "./Portfolio_Logo/Logo20.jpg";
import i43 from "./Portfolio_Logo/Logo21.jpg";
import i44 from "./Portfolio_Logo/Logo22.jpg";
import i45 from "./Portfolio_Logo/Logo23.jpg";
import i46 from "./Portfolio_Logo/Logo24.jpg";
import i47 from "./Portfolio_Logo/Logo25.jpg";
import i48 from "./Portfolio_Logo/Logo26.jpg";
import i49 from "./Portfolio_Logo/Logo27.jpg";
import i50 from "./Portfolio_Logo/Logo28.jpg";
import i51 from "./Portfolio_Logo/Logo3.jpg";
import i52 from "./Portfolio_Logo/Logo4.jpg";
import i53 from "./Portfolio_Logo/Logo5.jpg";
import i54 from "./Portfolio_Logo/Logo6.jpg";
import i55 from "./Portfolio_Logo/Logo7.jpg";
import i56 from "./Portfolio_Logo/Logo8.jpg";
import i57 from "./Portfolio_Logo/Logo9.jpg";
import i58 from "./REAL-ESTATE-RODEO/1.jpg";
import i59 from "./REAL-ESTATE-RODEO/2.jpg";
import i60 from "./REAL-ESTATE-RODEO/3.jpg";
import i61 from "./REAL-ESTATE-RODEO/4.jpg";
import i62 from "./REAL-ESTATE-RODEO/5.jpg";
import i63 from "./REAL-ESTATE-RODEO/Logo.jpg";
import i64 from "./Slider/1.jpg";
import i65 from "./Slider/10.jpg";
import i66 from "./Slider/11.jpg";
import i67 from "./Slider/2.jpg";
import i68 from "./Slider/3.jpg";
import i69 from "./Slider/4.jpg";
import i70 from "./Slider/5.jpg";
import i71 from "./Slider/6.jpg";
import i72 from "./Slider/7.jpg";
import i73 from "./Slider/8.jpg";
import i74 from "./Slider/9.jpg";
import i75 from "./Social_Media_Design/1.jpg";
import i76 from "./Social_Media_Design/2.jpg";
import i77 from "./Social_Media_Design/3.jpg";
import i78 from "./Social_Media_Design/4.jpg";
import i79 from "./Social_Media_Design/5.jpg";
import i80 from "./Social_Media_Design/6.jpg";
import i81 from "./Social_Media_Design/7.jpg";
import i82 from "./Social_Media_Page.jpg";
import i83 from "./UI_UX/1.jpg";
import i84 from "./UI_UX/10.jpg";
import i85 from "./UI_UX/11.jpg";
import i86 from "./UI_UX/12.jpg";
import i87 from "./UI_UX/13.jpg";
import i88 from "./UI_UX/14.jpg";
import i89 from "./UI_UX/15.jpg";
import i90 from "./UI_UX/17.jpg";
import i91 from "./UI_UX/18.jpg";
import i92 from "./UI_UX/19.jpg";
import i93 from "./UI_UX/2.jpg";
import i94 from "./UI_UX/20.jpg";
import i95 from "./UI_UX/3.jpg";
import i96 from "./UI_UX/4.jpg";
import i97 from "./UI_UX/5.jpg";
import i98 from "./UI_UX/6.jpg";
import i99 from "./UI_UX/7.jpg";
import i100 from "./UI_UX/8.jpg";
import i101 from "./UI_UX/9.jpg";
import i102 from "./hero.png";
import i103 from "./ottico brand/1.jpg";
import i104 from "./ottico brand/2.jpg";
import i105 from "./ottico brand/3.jpg";
import i106 from "./ottico brand/4.jpg";
import i107 from "./ottico brand/5.jpg";
import i108 from "./ottico brand/6.jpg";
import i109 from "./web.jpg";

const sizes = {
  [i0]: [1800, 1800],
  [i1]: [161, 161],
  [i2]: [1800, 1200],
  [i3]: [1800, 1165],
  [i4]: [1800, 1164],
  [i5]: [1800, 1200],
  [i6]: [1800, 1080],
  [i7]: [1800, 1080],
  [i8]: [1800, 1200],
  [i9]: [1800, 1200],
  [i10]: [1800, 1637],
  [i11]: [1273, 1800],
  [i12]: [1273, 1800],
  [i13]: [1391, 1800],
  [i14]: [1800, 1200],
  [i15]: [1273, 1800],
  [i16]: [1800, 1201],
  [i17]: [1800, 1426],
  [i18]: [1080, 1080],
  [i19]: [1080, 1080],
  [i20]: [1080, 1080],
  [i21]: [1800, 1200],
  [i22]: [1800, 1200],
  [i23]: [1800, 1800],
  [i24]: [2000, 2000],
  [i25]: [2000, 2000],
  [i26]: [2000, 2000],
  [i27]: [2000, 2000],
  [i28]: [2000, 2000],
  [i29]: [2000, 2000],
  [i30]: [1800, 1800],
  [i31]: [1800, 1800],
  [i32]: [1800, 1800],
  [i33]: [1800, 1800],
  [i34]: [1800, 1800],
  [i35]: [2000, 2000],
  [i36]: [2000, 2000],
  [i37]: [1800, 1800],
  [i38]: [1800, 1800],
  [i39]: [1799, 1800],
  [i40]: [1800, 1800],
  [i41]: [2000, 2000],
  [i42]: [2000, 2000],
  [i43]: [2000, 2000],
  [i44]: [1800, 1800],
  [i45]: [1800, 1800],
  [i46]: [2000, 2000],
  [i47]: [2000, 2000],
  [i48]: [2000, 2000],
  [i49]: [2000, 2001],
  [i50]: [1800, 1800],
  [i51]: [2000, 2000],
  [i52]: [1800, 1799],
  [i53]: [1800, 1800],
  [i54]: [1800, 1800],
  [i55]: [1800, 1800],
  [i56]: [1800, 1800],
  [i57]: [1800, 1800],
  [i58]: [1800, 1350],
  [i59]: [1800, 1350],
  [i60]: [1800, 1350],
  [i61]: [1800, 1350],
  [i62]: [1800, 1350],
  [i63]: [1800, 1350],
  [i64]: [1800, 1081],
  [i65]: [1600, 900],
  [i66]: [1800, 1012],
  [i67]: [1800, 1200],
  [i68]: [1800, 1081],
  [i69]: [1800, 1012],
  [i70]: [1600, 900],
  [i71]: [1800, 1012],
  [i72]: [1800, 1012],
  [i73]: [1800, 1012],
  [i74]: [1800, 1012],
  [i75]: [1800, 1800],
  [i76]: [1800, 666],
  [i77]: [1800, 1800],
  [i78]: [1800, 666],
  [i79]: [1800, 1800],
  [i80]: [1800, 666],
  [i81]: [1800, 666],
  [i82]: [1800, 1260],
  [i83]: [1800, 1800],
  [i84]: [1800, 1800],
  [i85]: [1800, 1800],
  [i86]: [1800, 1800],
  [i87]: [1800, 1800],
  [i88]: [1800, 1800],
  [i89]: [1800, 1800],
  [i90]: [1800, 1800],
  [i91]: [1800, 1800],
  [i92]: [1800, 1800],
  [i93]: [1800, 1800],
  [i94]: [1800, 1800],
  [i95]: [1800, 1800],
  [i96]: [1800, 1800],
  [i97]: [1800, 1800],
  [i98]: [1800, 1800],
  [i99]: [1800, 1800],
  [i100]: [1800, 1800],
  [i101]: [1800, 1800],
  [i102]: [1080, 1080],
  [i103]: [1080, 1080],
  [i104]: [1800, 1800],
  [i105]: [1800, 1800],
  [i106]: [1800, 1800],
  [i107]: [1800, 1800],
  [i108]: [1080, 1080],
  [i109]: [1800, 1800],
};

export default sizes;
